"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Children = _interopRequireDefault(require("./templates/Children"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var templates = {
  Children: _Children["default"]
};
var Carousel = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function Carousel() {
    (0, _classCallCheck2["default"])(this, Carousel);
    return _callSuper(this, Carousel, arguments);
  }
  (0, _inherits2["default"])(Carousel, _React$PureComponent);
  return (0, _createClass2["default"])(Carousel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        template = _this$props.template,
        settings = _this$props.settings,
        className = _this$props.className,
        outerDots = _this$props.outerDots,
        equalHeights = _this$props.equalHeights,
        upperArrows = _this$props.upperArrows,
        upperArrowText = _this$props.upperArrowText,
        showEdges = _this$props.showEdges,
        arrowsInner = _this$props.arrowsInner,
        bareArrows = _this$props.bareArrows;
      var TemplateSelected = templates[template];
      var carouselSettings = _objectSpread({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplaySpeed: 4000,
        speed: 500,
        arrows: false,
        adaptiveHeight: true,
        nextArrow: /*#__PURE__*/_react["default"].createElement(NextArrow, {
          bareArrows: bareArrows
        }),
        prevArrow: /*#__PURE__*/_react["default"].createElement(PrevArrow, {
          bareArrows: bareArrows
        })
      }, settings);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('d8-c-carousel', className, showEdges && 'd8-c-carousel-show-edges', outerDots && 'outer-dots', equalHeights && 'carousel-equal-height', upperArrows && 'upper-control--wrapper', arrowsInner && 'inner-arrows')
      }, upperArrowText && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-right padding-right-xxxl margin-bottom-lg d8-u-text-bold"
      }, upperArrowText), /*#__PURE__*/_react["default"].createElement(TemplateSelected, (0, _extends2["default"])({}, this.props, {
        carouselSettings: carouselSettings
      })));
    }
  }]);
}(_react["default"].PureComponent);
(0, _defineProperty2["default"])(Carousel, "propTypes", {
  settings: _propTypes["default"].object,
  template: _propTypes["default"].string,
  className: _propTypes["default"].string,
  getCarouselRef: _propTypes["default"].func,
  outerDots: _propTypes["default"].bool,
  equalHeights: _propTypes["default"].bool,
  upperArrows: _propTypes["default"].bool,
  upperArrowText: _propTypes["default"].string,
  showEdges: _propTypes["default"].bool,
  arrowsInner: _propTypes["default"].bool,
  bareArrows: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Carousel, "defaultProps", {
  template: 'Children',
  settings: {}
});
function NextArrow(props) {
  var onClick = props.onClick,
    bareArrows = props.bareArrows,
    className = props.className;
  var disabledClass = "";
  if (className.includes("slick-disabled")) {
    disabledClass = "slick-disabled";
  }
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "custom-arrows next ".concat(disabledClass),
    buttonType: bareArrows ? _constants.BUTTON_TYPES.BARE_WHITE : _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "arrow-right"
  }));
}
NextArrow.propTypes = {
  onClick: _propTypes["default"].func
};
function PrevArrow(props) {
  var onClick = props.onClick,
    bareArrows = props.bareArrows,
    className = props.className;
  var disabledClass = "";
  if (className.includes("slick-disabled")) {
    disabledClass = "slick-disabled";
  }
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "custom-arrows prev ".concat(disabledClass),
    buttonType: bareArrows ? _constants.BUTTON_TYPES.BARE_WHITE : _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "arrow-left"
  }));
}
PrevArrow.propTypes = {
  onClick: _propTypes["default"].func
};